<template>
    <div class="contract">
        <div class="searchPart">
            <div style="display:flex;align-items: center;">
                <el-input v-model="name" placeholder="签章名称"></el-input>
                <!--        <el-input v-model="contractName" placeholder="签章类型"></el-input>-->
                <el-button class="searchBtn" @click="search">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="reset">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <div class="toolRight">
<!--                <el-button type="text" size="small" @click="toDialog('add')">新增</el-button>-->
                <el-button type="primary" size="small" @click="toDialog('add')"><i class="el-icon-circle-plus-outline"></i>添加</el-button>
            </div>
        </div>
        <div class="contractTable">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                class="tableContent"
            >
                <el-table-column
                    prop="name"
                    label="签章名称"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="attachmentName"
                    label="签章附件"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>
                        <el-button type="text" size="small" @click="remove(scope.row.uuid)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
                class="pagination"
            >
            </el-pagination>
        </div>

        <!--添加/编辑签章弹出框-->
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            v-loading="loading"
            width="800px">
            <div class="dialogBoxClass">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="签章名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入签章名称"></el-input>
                    </el-form-item>
                    <el-form-item label="签章附件" prop="attachmentUrl">
                        <el-upload
                            class="avatar-uploader"
                            action="/service-center/upload/file/single"
                            accept="image/*"
                            :show-file-list="false"
                            :on-success="handleFileSuccess">
                            <img v-if="form.attachmentUrl" :src="form.attachmentUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
<!--                        <p class="el-upload__tip" style="font-size: 13px;line-height: normal;">请上传 590 * 375 的图片，且不超过2M</p>-->
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="submitForm">提交</el-button>
                        <el-button @click="dialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {
    deleteSignature,
    getSignatureInfo,
    getSignatureList,
    saveSignature,
    updateSignature
} from "../../utils/interface";

export default {
    name: "contract",
    data() {
        return {
            name: "",
            total: 0,
            current: 0,
            pageSize: 10,
            type: '',
            tableData: [],
            title: '',
            loading: false,
            form: {
                uuid:'',
                name:'',
                attachmentUrl: '',
                attachmentName: '',
            },
            rules: {
                name: [{required: true, message: '请输入签章名称',trigger: 'blur'}],
                attachmentUrl: [{required: true, message: '请上传附件', trigger: 'blur'}],
            },
            dialogVisible: false
        };
    },
    created() {
        this.search();
    },
    methods: {

        search() {
            let params = {
                name: this.name,
                current: this.current,
                pageSize: this.pageSize
            };
            getSignatureList(params).then((res) => {
                this.current = res.current;
                this.total = res.total;
                this.tableData = res.list;
            });
        },
        reset() {
            this.name = '';
            this.current = 1;
            this.search();
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.search();
        },
        // 点击打开添加/编辑签章弹出框
        toDialog(type,uuid){
            this.type = type
            this.dialogVisible = true
            this.form = {
                name: '',
            }

            if(type === 'add'){
                this.title = '添加签章'
            } else {
                this.title = '编辑签章'
                getSignatureInfo(uuid).then((res) => {
                    if (res.success) {
                        this.form = res.data;
                    }
                });
            }
        },

        remove(uuid){
            this.$confirm('确定要删除该签章吗' + '?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteSignature(uuid).then((res) => {
                    if (res.success) {
                        this.$message.success("删除成功");
                        this.search()
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },

        // 签章附件
        handleFileSuccess(res, file) {
            this.$set(this.form, 'attachmentUrl', res.url);
            this.$set(this.form, 'attachmentName', res.name);
            this.$refs.ruleForm.validateField('attachmentUrl');
        },

        submitForm(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    if(this.type === 'edit') {
                        updateSignature(this.form,this.form.uuid).then((res) => {
                            if (res.success) {
                                this.$message.success("编辑成功");
                                this.dialogVisible = false;
                                this.search()
                            }
                            this.loading = false
                        });
                    }else{
                        saveSignature(this.form).then((res) => {
                            if (res.success) {
                                this.$message.success("保存成功");
                                this.dialogVisible = false;
                                this.search()

                            }
                            this.loading = false
                        });
                    }
                    this.type = ''
                }else {
                    this.dialogVisible = true;
                    this.loading = false
                    // return false;
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.searchPart {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    /deep/ .el-input {
        width: initial;
        margin-bottom: 22px;
        margin-right: 30px;
    }

    /deep/ .el-input__inner {
        width: 242px;
        height: 35px;
        min-height: 35px;
        font-size: 12px;
        color: #999999;
        background-color: #f2f4f7;
        border: 1px solid #f2f4f7;
        border-radius: 5px;

        &:hover,
        &:focus {
            background-color: #fff;
            border: 1px solid #108ee9;
        }
    }

    /deep/ .el-input__prefix {
        top: -3px;
    }

    /deep/ .el-input__suffix {
        top: 2px;
    }

    /deep/ .el-button {
        display: block;
        line-height: 35px;
        padding: 0;
        height: 35px;
    }

    .searchBtn {
        width: 82px;
        background: #3d7fff;
        border: none;
        border-radius: 15px;
        font-size: 14px;
        color: #ffffff;
        margin-bottom: 22px;
    }

    .resetBtn {
        color: #333333;
        margin-bottom: 22px;
    }
}

.contract {
    padding: 20px;
}

.contractTable {
    .tableContent {
        min-height: 650px;
    }
}

.pagination {
    margin-top: 20px;
    text-align: right;
}

/deep/ .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
}

.avatar-uploader .el-upload {
    border: 1px dashed black;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px solid #ddd;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

/deep/ .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
}

.avatar-uploader .el-upload {
    border: 1px dashed black;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px solid #ddd;
}

.toolRight{
    button{
        width: 83px;
        height: 30px;
        background: rgba(21, 126, 251, 1);
        border: none;
        border-radius: 15px;
        font-size: 13px;
        color: #fff;
        i{
            padding-right: 5px;
        }
        &:hover{
            background: #61a2f0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/contract/signatureManage.vue